<template>
    <popper
        ref="popper"
        trigger="clickToToggle"
        root-class="cz3__steps-nav"
        transition="cz2__fade"
        :options="{
            placement: 'auto-start',
            modifiers: { offset: { offset: '20, 0px' } }
        }"
    >
        <div class="popper cz3__popper">
            <div class="cz3__steps-nav__steps">
                <button v-for="step in allSteps"
                    :key="step.step"
                    class="cz3__steps-nav__step"
                    :disabled="!step.seen"
                    @click.prevent="select(step.step)"
                >
                    <span class="cz3__steps-nav__check">
                        <!-- eslint-disable -->
                        <svg v-if="step.seen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                        <!-- eslint-enable -->
                    </span>

                    {{getLabel(step.step)}}
                </button>
            </div>

            <button
                :aria-label="$t('V3_CLOSE')"
                class="cz3__popper-close"
                @click.prevent="close"
            >
                <!-- eslint-disable -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><mask id="close-a" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#close-a)"><path fill="#000" d="m5.334 15.833-1.167-1.166L8.834 10 4.167 5.333l1.167-1.166L10 8.833l4.667-4.666 1.167 1.166L11.167 10l4.667 4.667-1.167 1.166L10 11.167l-4.666 4.666Z"/></g></svg>
                <!-- eslint-disable -->
            </button>
        </div>

        <button slot="reference" class="cz3__step-info">
            <template v-if="largeLabel && label !== largeLabel">
                <div class="cz3__step-info__name">
                    <span class="cz3__hide-lg">{{label}}</span>
                    <span class="cz3__hide-sm">{{largeLabel}}</span>

                    <span class="cz3__step-info__down">
                        <!-- eslint-disable -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
                        <!-- eslint-enable -->
                    </span>
                </div>
            </template>
            <div v-else class="cz3__step-info__name">
                {{label}}

                <span class="cz3__step-info__down">
                    <!-- eslint-disable -->
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
                    <!-- eslint-enable -->
                </span>
            </div>

            <slot />
        </button>
    </popper>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__step-info {
            display: flex;
            flex-direction: row;

            justify-content: flex-start;
            align-items: center;

            padding: 0 16px;

            gap: 16px;

            text-align: left;

            @include respond-above(sm) {
                padding: 0 32px;

                gap: 40px;
            }
        }

        .cz3__form-fields-main-scroll {
            .cz3__step-info {
                @include respond-above(sm) {
                    padding: 0;
                }
            }
        }

        .cz3__step-info__name {
            flex: 1 1 0;

            font-family: $font-main;
            font-weight: 700;
            font-size: 18px;

            @include respond-above(sm) {
                font-weight: 500;
                font-size: 20px;
            }
        }

        .cz3__step-info__down {
            margin-left: 5px;

            svg {
                display: inline-block;

                width: 16px;

                vertical-align: -2px;
            }
        }

        .cz3__steps-nav__step {
            display: flex;

            justify-content: flex-start;
            align-items: center;

            gap: 10px;

            min-width: 300px;

            font-family: $font-main;
            font-weight: 700;
            font-size: 16px;

            height: 40px;

            color: #000;

            &:disabled {
                opacity: 0.5;
            }
        }

        .cz3__steps-nav__check {
            width: 16px;

            svg {
                width: 16px;
                vertical-align: -1px;
            }
        }
    }
</style>

<script>
    import Popper from 'vue-popperjs';

    export default {
        components: {
            Popper,
        },

        props: {
            label: String,
            largeLabel: String,
        },

        computed: {
            allSteps() {
                return this.$store.getters.allStepsV3;
            },

            selectedStep() {
                return this.$store.state.selectedStepV3;
            },

            selectedSubStep() {
                return this.$store.state.selectedSubStepV3;
            },

            availableSides() {
                return this.$store.getters.availableSidesV3;
            },
        },

        methods: {
            close() {
                this.$refs.popper.doClose();
            },

            select(step) {
                this.close();

                this.$store.dispatch('setSelectedStepV3', step);
                this.$store.dispatch('setSelectedSubStepV3', 'choose');
            },

            getLabel(step) {
                if (step === 'itemColors') {
                    return this.$t('V3_ITEM_COLOR');
                }

                if (step === 'review') {
                    return this.$t('V3_STEP_REVIEW');
                }

                let designIndex = 0;
                let surfaceIndex = 0;

                if (step === 'design-1') {
                    designIndex = 0;
                    surfaceIndex = 0;
                }

                if (step === 'design-1-1') {
                    designIndex = 0;
                    surfaceIndex = 1;
                }

                if (step === 'design-2') {
                    designIndex = 2;
                    surfaceIndex = 0;
                }

                if (step === 'design-2-1') {
                    designIndex = 2;
                    surfaceIndex = 1;
                }

                if (step === 'design-3') {
                    designIndex = 4;
                    surfaceIndex = 0;
                }

                if (step === 'design-3-1') {
                    designIndex = 4;
                    surfaceIndex = 1;
                }

                const side = this.availableSides[designIndex];

                const firstOrSecond = surfaceIndex === 0 ? this.$t('V3_DESIGN_FIRST') : this.$t('V3_DESIGN_SECOND');

                if (side === 'front') {
                    return `${this.$t('V3_DESIGN_FRONT')}${firstOrSecond}`;
                }

                if (side === 'back') {
                    return `${this.$t('V3_DESIGN_BACK')}${firstOrSecond}`;
                }

                if (side === 'backtop') {
                    return `${this.$t('V3_DESIGN_BACK_TOP')}${firstOrSecond}`;
                }

                return '';
            },
        },
    };
</script>
